// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ContactBlock-module-contactBlockWrapper-hddFb{display:inline-flex;gap:var(--spacing-3xl);flex-wrap:wrap}.ContactBlock-module-contactBlockWrapper-hddFb.ContactBlock-module-horizontal-lkx4g{flex-direction:row}.ContactBlock-module-contactBlockWrapper-hddFb.ContactBlock-module-vertical-mdS1p{flex-direction:column;gap:var(--spacing-sl)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contactBlockWrapper": "ContactBlock-module-contactBlockWrapper-hddFb",
	"horizontal": "ContactBlock-module-horizontal-lkx4g",
	"vertical": "ContactBlock-module-vertical-mdS1p"
};
export default ___CSS_LOADER_EXPORT___;
